<template>
    <img src="/layout/images/lfi.png" alt="Law Firm Intelligence" />
</template>
